import { SwapDto } from '../types/dto/Swap.dto';
import { NFTMetadata } from '../types/dto/UserNFTs.dto';
import { AxiosResponse } from 'axios';
import { fetchWithErrorHandling } from './axios';

export const fetchAllTokensMetadata = async (swapsToParse: SwapDto[]): Promise<{ [address: string]: NFTMetadata }> => {
  //address is complete id "identifier-nftContractAddress"
  const uniqueTokenListWithUris: { [address: string]: string } = {};

  swapsToParse?.map((swap) => {
    swap.initiatorNfts.map((nft) => {
      uniqueTokenListWithUris[nft.id] = nft.tokenUri;
    });
    swap.secondUserNfts.map((nft) => {
      uniqueTokenListWithUris[nft.id] = nft.tokenUri;
    });
  });

  const metadataPromises: { [address: string]: Promise<AxiosResponse<NFTMetadata>> } = {};
  Object.keys(uniqueTokenListWithUris).map(
    (address) => (metadataPromises[address] = fetchWithErrorHandling(uniqueTokenListWithUris[address])),
  );

  const responses = await Promise.allSettled(Object.values(metadataPromises));
  const metadatas: { [address: string]: NFTMetadata } = {};
  Object.keys(metadataPromises).map((address, index) => {
    if (responses[index].status === 'fulfilled') {
      metadatas[address] = (responses[index] as PromiseFulfilledResult<AxiosResponse<NFTMetadata>>).value.data;
    }
  });

  return metadatas;
};
